var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeManageInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20696 20.9173C2.63406 20.9173 2.14379 20.7135 1.73616 20.3059C1.32853 19.8982 1.12437 19.4076 1.12367 18.834V7.08919C0.811181 6.89822 0.559451 6.651 0.368483 6.34753C0.177515 6.04405 0.0820312 5.69232 0.0820312 5.29232V2.16732C0.0820312 1.5944 0.286193 1.10412 0.694517 0.696485C1.10284 0.288846 1.59311 0.0846788 2.16532 0.0839844H18.8316C19.4045 0.0839844 19.8951 0.288151 20.3034 0.696485C20.7118 1.10482 20.9156 1.5951 20.9149 2.16732V5.29232C20.9149 5.69162 20.8194 6.04336 20.6284 6.34753C20.4375 6.65169 20.1857 6.89857 19.8732 7.08815V18.834C19.8732 19.4069 19.6694 19.8975 19.2618 20.3059C18.8542 20.7142 18.3636 20.918 17.79 20.9173H3.20696ZM3.20696 7.37565V18.834H17.79V7.37565H3.20696ZM2.16532 5.29232H18.8316V2.16732H2.16532V5.29232ZM8.41517 12.584H12.5817C12.8769 12.584 13.1244 12.484 13.3244 12.284C13.5244 12.084 13.6241 11.8368 13.6234 11.5423C13.6227 11.2479 13.5227 11.0007 13.3234 10.8007C13.1241 10.6007 12.8769 10.5007 12.5817 10.5007H8.41517C8.12004 10.5007 7.87283 10.6007 7.67352 10.8007C7.47422 11.0007 7.37423 11.2479 7.37353 11.5423C7.37284 11.8368 7.47284 12.0843 7.67352 12.285C7.87421 12.4857 8.12143 12.5854 8.41517 12.584Z",
    fill: "#600AAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeManageInventory);
export default __webpack_public_path__ + "static/media/homeManageInventory.9cfe06e057b74035985736fa872e3c1d.svg";
export { ForwardRef as ReactComponent };